import { getTotalPrice, multiplyMoney, getMinPrice as getMoneyMinPrice } from '@shared/lib/money';
import { Baggage, Measurement } from '../BaggageService/types';
import { SelectedAdditionalBaggage } from '../Baggage/AdditionalBaggage/types';
import { SelectedBaggageService } from '../Baggage/types';
import { ServicePayload } from '../Checkout/store/selectedServices/actions';
import { Money } from '../types';
import { FareFamilyFragment, BaggageType, FareFamilyOptionsType, FareFeaturePaymentType } from '@websky/graphql';

export const parseIncludedBaggage = (
	fareFamiliesMap: Map<string, { fareFamily: FareFamilyFragment; segmentIds: string[] }>,
	passengers: string[]
): Baggage[] => {
	const includedBaggage: Baggage[] = [];

	fareFamiliesMap.forEach(({ segmentIds, fareFamily }) => {
		fareFamily.options
			.filter(
				option =>
					(option.type === FareFamilyOptionsType.CarryOn || option.type === FareFamilyOptionsType.Baggage) &&
					option.availability === FareFeaturePaymentType.Free
			)
			.forEach(option => {
				const splittedValue = option.value.split('x'),
					value = splittedValue.length === 2 ? splittedValue[1] : option.value;

				includedBaggage.push({
					id: null,
					segmentIds: [segmentIds.map(segmentId => segmentId)],
					includedSegments: segmentIds.map(segmentId => segmentId),
					type: option.type === 'CarryOn' ? BaggageType.CarryOn : BaggageType.CheckedBaggage,
					name: option.title,
					included: parseInt(splittedValue[0]),
					price: null,
					value: {
						amount: parseInt(value),
						measurement: Measurement.Kilograms
					},
					size: option.size,
					allowedPassengers: passengers,
					canBeAdded: false,
					rfics: ''
				});
			});
	});

	return includedBaggage;
};

export const getPriceToPay = (selectedServices: SelectedAdditionalBaggage[], services: Baggage[]): Money | null => {
	const prices: Money[] = [];

	services.forEach(service => {
		selectedServices
			.filter(selected => selected.serviceId === service.id)
			.forEach(selected => {
				prices.push(multiplyMoney(service.price, selected.count * selected.segmentIds.length));
			});
	});

	return prices.length ? getTotalPrice(prices, price => price) : null;
};

export const getMinPrice = (services: Baggage[]): Money | null => {
	const prices: Money[] = [];

	services.forEach(service => {
		if (!service.price) {
			return;
		}

		service.segmentIds.forEach(segmentIds => {
			prices.push(multiplyMoney(service.price, segmentIds.length));
		});
	});

	if (!prices.length) {
		return null;
	}

	const paidPrices = prices.filter(price => price.amount);

	return getMoneyMinPrice(paidPrices.length ? paidPrices : prices, price => price);
};

export const baggageServicesToDeletePayloadAdapter = (services: SelectedBaggageService[]): ServicePayload[] =>
	services.map(service => ({
		passengerId: service.passengerId,
		serviceId: service.serviceId,
		segmentId: service.segmentIds[0],
		allowedSegments: [service.segmentIds],
		count: service.confirmedCount ?? 0
	}));
